export const PROGRAM_UNIT_STATUS = {
  DRAFT: 'DRAFT',
  DONE: 'DONE'
};
